import { ColumnWrapper } from './ColumnWrapper';
import { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ColumnWithVirtualization = ({
  columnData,
  isBoardEmpty,
  isColumnVisible
}) => {
  const [shouldRenderCards, setShouldRenderCards] = useState(isColumnVisible);
  useEffect(() => {
    if (isColumnVisible && !shouldRenderCards) {
      setShouldRenderCards(true);
    }
  }, [isColumnVisible, shouldRenderCards]);
  return /*#__PURE__*/_jsx(ColumnWrapper, {
    columnData: columnData,
    isBoardEmpty: isBoardEmpty,
    shouldRenderCards: shouldRenderCards
  });
};
export default ColumnWithVirtualization;